var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3661 21C19.5716 21 20.5495 20.0221 20.5495 18.8166V10.0539C20.5378 9.38157 20.2186 8.75108 19.6835 8.34437L13.7609 3.61663C12.7208 2.79446 11.2526 2.79446 10.2115 3.61663L4.31518 8.34826C3.77614 8.75497 3.457 9.38741 3.44922 10.0627V18.8166C3.44922 20.0221 4.42707 21 5.6326 21H7.4696C8.55837 21 9.44087 20.1175 9.44087 19.0297V14.95C9.44087 13.9575 10.2446 13.1529 11.237 13.1529H12.8123C13.8047 13.1529 14.6094 13.9575 14.6094 14.95V19.0297C14.6094 20.1175 15.4919 21 16.5797 21H18.3661Z",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c59dbdc8124b4ea165c991e71ee79bc0.svg";
export { ForwardRef as ReactComponent };